// extracted by mini-css-extract-plugin
export default {"image-placeholder":"cropper_image-placeholder__WJl+i","image-placeholder-circle":"cropper_image-placeholder-circle__kp13u"};